module.exports={render:function (){with(this) {
  return _m(0)
}},staticRenderFns: [function (){with(this) {
  return _h('div', [_h('h1', ["This is a web experiment"]), " ", _h('p', ["\n    Sorry, your browser does not support the Web Audio API, which is an integral part of this\n    experiment.\n  "]), " ", _h('p', {
    staticClass: "note"
  }, ["\n    Currently supported browsers are\n    ", _h('a', {
    attrs: {
      "href": "http://google.com/chrome",
      "target": "_blank"
    }
  }, ["Chrome 10+"]), ",\n    ", _h('a', {
    attrs: {
      "href": "http://www.mozilla.org/en-US/firefox/new/",
      "target": "_blank"
    }
  }, ["Firefox 25+"]), ",\n    ", _h('a', {
    attrs: {
      "href": "http://www.opera.com/",
      "target": "_blank"
    }
  }, ["Opera 15+"]), ", and\n    ", _h('a', {
    attrs: {
      "href": "http://www.apple.com/au/safari/",
      "target": "_blank"
    }
  }, ["Safari 6+"]), ".\n  "])])
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-9b6965cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Unsupported.vue
 ** module id = 168
 ** module chunks = 2
 **/